var map = {
	"./IMAGE000007.jpeg": "2177",
	"./IMAGE00007.jpeg": "c9a4",
	"./IMAGE007.jpeg": "c387",
	"./IMAGE02.jpeg": "bb50",
	"./IMAGE3MESINOFFSET.jpeg": "0953",
	"./IMAGE3MESINOFFSET2.jpeg": "809d",
	"./IMAGE3MESINPUNCH.jpeg": "a36a",
	"./IMAGE3MESINVARNISH.jpeg": "6e05",
	"./IMAGE7.jpeg": "f074",
	"./flexo.jpeg": "ec93",
	"./greaseproof.jpeg": "3894",
	"./image_01.jpeg": "7db2",
	"./imagesalada.jpeg": "e270",
	"./kertas-nasi.jpeg": "ba0d",
	"./paper01.jpeg": "70be",
	"./paper02.jpeg": "7d14",
	"./paper03.jpeg": "ad62",
	"./paper04.jpeg": "b479"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fe4c";